import React from "react";
import { ConfigureCommunicationContainer } from "../../../containers";

const ConfigureCommunication = (props) => {
  return <ConfigureCommunicationContainer {...props} />;
};

export default ConfigureCommunication;
